// extracted by mini-css-extract-plugin
export var bonus = "component-module--bonus--3kd_A";
export var wrap = "component-module--wrap--3qzvp";
export var h1 = "component-module--h1--2O1Er";
export var h2 = "component-module--h2--29pJL";
export var sizebig = "component-module--sizebig--1WHpz";